import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ca5e6db0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-logo" }, null, -1))
const _hoisted_4 = { class: "top-contact" }
const _hoisted_5 = { class: "banner" }
const _hoisted_6 = { class: "bww-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bww J_uwic",
  cbv: "12",
  href: "javascript:void(0);"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"new-main\" data-v-ca5e6db0><div class=\"main-one\" data-v-ca5e6db0></div><div class=\"main-two\" data-v-ca5e6db0></div></div><div class=\"footer-banner\" data-v-ca5e6db0></div><div class=\"pendant\" data-v-ca5e6db0></div>", 3)
const _hoisted_11 = { class: "global-footer" }
const _hoisted_12 = { class: "footer-share" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "http://www.weibo.com/u/5096795969",
  target: "_blank",
  rel: "noopener noreferrer",
  class: "J_btn share-sina",
  stat: "cmcn-share-a",
  down: "5"
}, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "footer-link" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "//www.ijinshan.com/about/about.shtml",
    target: "_blank",
    rel: "noopener noreferrer",
    stat: "cmcn-footer-a",
    down: "6",
    class: "J_btn"
  }, "公司介绍"),
  /*#__PURE__*/_createTextVNode("| "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://hr.cmcm.com/social",
    target: "_blank",
    rel: "noopener noreferrer",
    stat: "cmcn-footer-b",
    down: "7",
    class: "J_btn"
  }, "全球招聘"),
  /*#__PURE__*/_createTextVNode("| "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "//www.ijinshan.com/about/about.shtml",
    target: "_blank",
    rel: "noopener noreferrer",
    stat: "cmcn-footer-d",
    down: "9",
    class: "J_btn"
  }, "联系我们"),
  /*#__PURE__*/_createTextVNode("| "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://www.cmcm.com/en-us/",
    target: "_blank",
    rel: "noopener noreferrer",
    stat: "cmcn-footer-e",
    down: "10",
    class: "J_btn"
  }, "Global")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "footer-copy" }, [
  /*#__PURE__*/_createElementVNode("em", null, "Copyright © 2021 珠海海鸟科技有限公司")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "footer-copy" }, [
  /*#__PURE__*/_createElementVNode("em", null, "粤ICP备18107911号")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sign = _resolveComponent("Sign")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", {
          class: "top-hz",
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeTopContact())),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeTopContact()))
        }, "商务合作", 32),
        _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
          [_vShow, _ctx.showTopContact]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_Sign, { msg: "大客户登录" })
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("span", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("a", {
          id: "J_shareWx",
          href: "javascript:;",
          class: "share-wx",
          stat: "cmcn-share-b",
          onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeCmcmCode())),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeCmcmCode()))
        }, null, 32)
      ]),
      _hoisted_14,
      _hoisted_15,
      _hoisted_16,
      _createElementVNode("span", {
        id: "J_cmcnCode",
        class: _normalizeClass(["cmcn-code", {'code-show': _ctx.showCmcmCode}])
      }, null, 2)
    ])
  ], 64))
}